export default class ClientCompanyModel {
    ClientCompanyId: number; 
	ClientCompanyName: string;
	Description: string;
	ClientCompanyTypeId: number; 
	RMName1: string;
	RMContact1: string;
	RMName2: string;
	RMContact2: string;
	RMName3: string;
	RMContact3: string;
}

export class SelectedCompanyModel {
	ClientCompanyId: number; 
	ReferenceNumber: string;
}
